import { render, staticRenderFns } from "./AreaProjectApplyDetail.vue?vue&type=template&id=3d274280&scoped=true&"
import script from "./AreaProjectApplyDetail.vue?vue&type=script&lang=js&"
export * from "./AreaProjectApplyDetail.vue?vue&type=script&lang=js&"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&lang=css&"
import style1 from "./AreaProjectApplyDetail.vue?vue&type=style&index=1&id=3d274280&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d274280",
  null
  
)

export default component.exports